// extracted by css-extract-rspack-plugin
export default {"patternFill":"h5kpV0uzPeMMiZlK","patternStroke":"rBdawtos7nkCBlLO","waveStroke":"LxHTU1IAt4HJb_zf"};